import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      queryParams.append(key, params[key].toString());
    });
  }
  return `${baseUrl}?${queryParams.toString()}`;
}

function getPackages(params: {
  limit: number;
  skip: number;
  keyword?: string;
  owner?: string;
  country?: string;
}) {
  const baseUrl = "packages";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching packages:", error);
  }
}

function createPackageApi(params: {
  name: string;
  pack: { [countryCode: string]: number };
}) {
  const baseUrl = "packages";
  const url = buildUrl(baseUrl);

  try {
    return getApiInstance().post(url, params);
  } catch (error) {
    console.error("Error creating package:", error);
  }
}

function deletePackageApi(params: { ids: string[] }) {
  const baseUrl = "packages";
  const url = `${baseUrl}/delete`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error deleting package:", error);
  }
}

function updatePackageApi(params: {
  id: string;
  name: string;
  pack: { [countryCode: string]: number };
}) {
  const baseUrl = "packages";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error updating package:", error);
  }
}

function getPackage(params: { id: string }) {
  const baseUrl = "packages";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching package:", error);
  }
}

export {
  getPackages,
  createPackageApi,
  getPackage,
  updatePackageApi,
  deletePackageApi,
};
